module.exports = __webpack_public_path__ + "img/type--1-spans--single-lang--es.57085ae5.jpg";